import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });
  return (
    <motion.div
      data-testid="scroll-progress"
      style={{ scaleX }}
      className="fixed top-10 left-0 right-0 h-[3px] bg-brand-red origin-left z-[70]"
    />
  );
};

export const CustomCursor = () => {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    const move = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
      const el = e.target;
      setHovering(!!(el.closest && el.closest("a,button,[role=button],input,textarea,select")));
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        className="fixed top-0 left-0 z-[80] pointer-events-none rounded-full border border-brand-red"
        animate={{
          x: pos.x - (hovering ? 22 : 16),
          y: pos.y - (hovering ? 22 : 16),
          width: hovering ? 44 : 32,
          height: hovering ? 44 : 32,
          opacity: hovering ? 1 : 0.6,
        }}
        transition={{ type: "spring", stiffness: 400, damping: 28, mass: 0.4 }}
      />
      <motion.div
        className="fixed top-0 left-0 z-[80] pointer-events-none w-1.5 h-1.5 rounded-full bg-brand-red"
        animate={{ x: pos.x - 3, y: pos.y - 3 }}
        transition={{ type: "spring", stiffness: 800, damping: 30, mass: 0.2 }}
      />
    </>
  );
};
